module.exports = __webpack_public_path__ + "static/img/one-fold-character.3cfeb4a.png";